export enum LoginWithCredentialsLocalizationId {
    LogInTitle = "sign-in-enter-credential.log_in_title",
    CredentialsTitle = "sign-in-enter-credential.credentials_title",
    UsernameLabel = "sign-in-enter-credential.username_label",
    PasswordLabel = "sign-in-enter-credential.password_label",
    LoginButton = "sign-in-enter-credential.login_button",
    BackButton = "sign-in-enter-credential.back_button",
    StepPicture = "sign-in-enter-credential.step_picture",
}
